import React, { useState, useEffect } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import {
  FaChevronLeft,
  FaChevronRight,
  FaSearchPlus,
  FaSearchMinus,
} from "react-icons/fa"; // Import zoom icons
import { albums } from "../../assets/data/albums";

const PhotoDetails = () => {
  const { id, photoIndex } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const album = albums.find((a) => a.id === parseInt(id));
  const currentIndex = parseInt(photoIndex);
  const photo = album?.photos[currentIndex];

  const [zoom, setZoom] = useState(1);

  useEffect(() => {
    const handlePopState = () => {
      if (location.pathname.includes(`/login/albums/${id}/photos`)) {
        navigate(`/login/albums/${id}`, { replace: true });
      }
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [id, location.pathname, navigate]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "ArrowLeft") {
        goToPreviousPhoto();
      } else if (event.key === "ArrowRight") {
        goToNextPhoto();
      } else if (event.key === "+" || event.key === "=") {
        zoomIn();
      } else if (event.key === "-") {
        zoomOut();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [currentIndex]);

  if (!album) {
    return <h2>Album not found!</h2>;
  }

  if (!photo || currentIndex < 0 || currentIndex >= album.photos.length) {
    return <h2>Photo not found!</h2>;
  }

  const goToPreviousPhoto = () => {
    if (album && album.photos.length > 0) {
      const prevIndex =
        (currentIndex - 1 + album.photos.length) % album.photos.length;
      navigate(`/login/albums/${id}/photos/${prevIndex}`, { replace: true });
    }
  };

  const goToNextPhoto = () => {
    if (album && album.photos.length > 0) {
      const nextIndex = (currentIndex + 1) % album.photos.length;
      navigate(`/login/albums/${id}/photos/${nextIndex}`, { replace: true });
    }
  };

  const goToAlbum = () => {
    navigate(`/login/albums/${id}`);
  };

  const zoomIn = () => {
    setZoom((prevZoom) => (prevZoom >= 1.5 ? 1.5 : prevZoom + 0.1));
  };

  const zoomOut = () => {
    setZoom((prevZoom) => (prevZoom <= 1 ? 1 : prevZoom - 0.1));
  };

  return (
    <div
      style={{
        textAlign: "center",
        padding: "20px",
        position: "relative", // Required for absolute positioning of the Back button
      }}
    >
      {/* Back Button - Positioned at the top left */}
      <div
        style={{
          position: "absolute",
          top: "20px",
          left: "20px",
        }}
      >
        <button
          onClick={goToAlbum}
          style={{
            padding: "10px 20px",
            backgroundColor: "#1890ff",
            color: "white",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
          }}
        >
          Back
        </button>
      </div>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "20px",
        }}
      >
        <span
          onClick={goToPreviousPhoto}
          style={{
            fontSize: "1.5rem",
            cursor: "pointer",
            userSelect: "none",
            transition: "color 0.3s",
          }}
          onMouseEnter={(e) => (e.target.style.color = "#007bff")}
          onMouseLeave={(e) => (e.target.style.color = "black")}
        >
          <FaChevronLeft />
        </span>

        <div
          style={{
            width: "800px",
            height: "600px",
            overflow: "hidden",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "10px",
            border: "1px solid #ccc",
            position: "relative",
          }}
        >
          <img
            src={photo}
            alt={`Photo ${currentIndex + 1}`}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              transform: `scale(${zoom})`,
              transition: "transform 0.3s ease-in-out",
            }}
          />
        </div>

        <span
          onClick={goToNextPhoto}
          style={{
            fontSize: "1.5rem",
            cursor: "pointer",
            userSelect: "none",
            transition: "color 0.3s",
          }}
          onMouseEnter={(e) => (e.target.style.color = "#007bff")}
          onMouseLeave={(e) => (e.target.style.color = "black")}
        >
          <FaChevronRight />
        </span>
      </div>

      {/* Zoom Controls */}
      <div
        style={{
          marginTop: "20px",
          display: "flex",
          justifyContent: "center",
          gap: "20px",
        }}
      >
        <span
          onClick={zoom > 1 ? zoomOut : undefined}
          style={{
            fontSize: "1.5rem",
            cursor: zoom > 1 ? "pointer" : "not-allowed",
            userSelect: "none",
            color: zoom > 1 ? "black" : "gray",
            transition: "color 0.3s",
          }}
          onMouseEnter={(e) => zoom > 1 && (e.target.style.color = "#007bff")}
          onMouseLeave={(e) => zoom > 1 && (e.target.style.color = "black")}
        >
          <FaSearchMinus />
        </span>
        <span
          onClick={zoom < 1.3 ? zoomIn : undefined}
          style={{
            fontSize: "1.5rem",
            cursor: zoom < 1.3 ? "pointer" : "not-allowed",
            userSelect: "none",
            color: zoom < 1.3 ? "black" : "gray",
            transition: "color 0.3s",
          }}
          onMouseEnter={(e) => zoom < 1.3 && (e.target.style.color = "#007bff")}
          onMouseLeave={(e) => zoom < 1.3 && (e.target.style.color = "black")}
        >
          <FaSearchPlus />
        </span>
      </div>
    </div>
  );
};

export default PhotoDetails;
